export default function () {
	const h = document.getElementById('header');
	const doc = document.documentElement;

	let prevScroll = window.scrollY || doc.scrollTop;
	let curScroll;
	let delta = 300;
	let direction = 0;
	let prevDirection = 0;

	const toggleHeader = (direction, curScroll) => {
		if (direction === 1) {
			doc.classList.remove('header-hide');
			prevDirection = direction;
		} else if (direction === 2 && curScroll > delta) {
			doc.classList.add('header-hide');
			prevDirection = direction;
		}
	};

	const onScroll = () => {
		curScroll = window.scrollY || doc.scrollTop;
		if (curScroll > prevScroll) {
			direction = 2;
		} else if (curScroll < prevScroll) {
			direction = 1;
		}

		if (direction !== prevDirection) {
			toggleHeader(direction, curScroll);
		}

		prevScroll = curScroll;
	};

	const setHeight = () => doc.style.setProperty('--wp--header--height', `${h.offsetHeight}px`);

	window.addEventListener('load', () => {
		setHeight();

		// Add your file input change event listeners here
		document.getElementById('resume-upload').addEventListener('change', function() {
			var fileName = this.files[0].name;
			var resumeLabel = document.querySelector('.wpcf7-form-control-wrap[data-name="resume"]');
			resumeLabel.setAttribute('data-content', fileName);
		});

		document.getElementById('headshot-upload').addEventListener('change', function() {
			var fileName = this.files[0].name;
			var resumeLabel = document.querySelector('.wpcf7-form-control-wrap[data-name="headshot"]');
			resumeLabel.setAttribute('data-content', fileName);
		});
	});

	window.addEventListener('resize', am2.fn.debounce(setHeight, 100));
	window.addEventListener('scroll', am2.fn.debounce(onScroll, 5));


	window.addEventListener('DOMContentLoaded', function() {  
		var placeholder = document.getElementById('image-placeholder');
		var iframe = document.getElementById('video-iframe');
	
		setTimeout(function() {
			if (placeholder) {
				placeholder.style.display = 'none';
			}
			if (iframe) {
				iframe.style.display = 'block';
			}
		}, 800);  
	});
};
